import { useCallback, useEffect, useRef, useState } from 'react';

const DEFAULT_DURATION = 1500;

// Shows on mount, hides after `duration`. reveal() shows it again and restarts
// the timer. held=true keeps it hidden and stops the timer.
const useTemporaryReveal = ({ duration = DEFAULT_DURATION, held = false }) => {
  const [isRevealed, setIsRevealed] = useState(true);
  const timeoutRef = useRef(null);

  const clear = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  const reveal = useCallback(() => {
    clear();
    setIsRevealed(true);
    timeoutRef.current = setTimeout(() => setIsRevealed(false), duration);
  }, [clear, duration]);

  // Also covers the first appearance, so mount and re-reveal share one timer
  useEffect(() => {
    // No setIsRevealed(false) here: the returned value already accounts for
    // held, and setting it would cost an extra render on every zoom
    if (held) {
      clear();
      return undefined;
    }

    reveal();
    return clear;
  }, [clear, held, reveal]);

  return { isRevealed: isRevealed && !held, reveal };
};

export default useTemporaryReveal;
